export default "__VITE_ASSET__ItourF2z__"